import { useEffect, useState, useContext } from 'react';
import { RequestsManagementsAPI } from '../../services/external/APIs/requests-managements/RequestsManagements';
import {
    InterruptionRequestModel,
    RequestModel,
    SchedulingChangeRequestModel,
} from '../../models/requests-management/requests';
import { AppContext } from '../../common';
import { toast } from 'react-toastify';

interface DetailsRequestProps {
    id: string;
    type: string;
    status?: string;
    changeSelectedId: (newState: string) => void;
    handleFetchPendingRquests: () => void;
}

const VALID_STATUS = ['approved', 'rejected'];

export const DetailsRequest = ({
    id,
    type,
    status,
    changeSelectedId,
    handleFetchPendingRquests,
}: DetailsRequestProps) => {
    const { isSkinSmart, langResources } = useContext(AppContext);

    const [isLoading, setIsLoading] = useState(false);
    const [comments, setComments] = useState('');

    const [selectedWorkshift, setSelectedWorkshift] =
        useState<SchedulingChangeRequestModel>();
    const [selectedInterruption, setSelectedInterruption] =
        useState<InterruptionRequestModel>();

    useEffect(() => {
        if (selectedInterruption) {
            setComments(selectedInterruption.comments ?? '');
        }
    }, [selectedInterruption]);

    useEffect(() => {
        if (type == 'workshift') {
            setIsLoading(true);

            RequestsManagementsAPI.getSchedulingChangeRequestById(Number(id))
                .then((response) => {
                    setSelectedWorkshift(response);
                })
                .finally(() => setIsLoading(false));
        } else if (type == 'interruption') {
            setIsLoading(true);

            RequestsManagementsAPI.getInterruptionRequestById(Number(id))
                .then((response) => {
                    setSelectedInterruption(response);
                })
                .finally(() => setIsLoading(false));
        }
    }, [id]);

    const handlerSubmit = (statusParam: string) => {
        setIsLoading(true);

        let body: RequestModel = {
            commentsInterruption: type == 'interruption' ? comments : null,
            commentsScheduling: type == 'workshift' ? comments : null,
            interruptionRequestId: type == 'interruption' ? Number(id) : null,
            schedulingChangeRequestId: type == 'workshift' ? Number(id) : null,
            isSkinSmart,
        };

        if (status == 'approved' || statusParam == 'approved') {
            RequestsManagementsAPI.approvedSchedulingChangeRequest(body)
                .then((response) => {
                    toast.success(response.message, {
                        autoClose: 5000,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        closeOnClick: true,
                        closeButton: true,
                    });
                    changeSelectedId('');
                })
                .catch((e) => {
                    toast.error(
                        e.response?.data ??
                        'Ocurrió un error al aprobar esta solicitud',
                        {
                            autoClose: 5000,
                            position: toast.POSITION.BOTTOM_RIGHT,
                            closeOnClick: true,
                            closeButton: true,
                        }
                    );
                })
                .finally(() => {
                    handleFetchPendingRquests();
                    setIsLoading(false);
                });
        } else if (status == 'rejected' || statusParam == 'rejected') {
            RequestsManagementsAPI.rejectSchedulingChangeRequest(body)
                .then((response) => {
                    toast.success(response.message, {
                        autoClose: 5000,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        closeOnClick: true,
                        closeButton: true,
                    });
                    changeSelectedId('');
                })
                .catch((e) => {
                    toast.error(
                        e.response?.data ??
                        'Ocurrió un error al rechazar esta solicitud',
                        {
                            autoClose: 5000,
                            position: toast.POSITION.BOTTOM_RIGHT,
                            closeOnClick: true,
                            closeButton: true,
                        }
                    );
                })
                .finally(() => {
                    handleFetchPendingRquests();
                    setIsLoading(false);
                });
        }
    };

    const downloadFile = (contractId: number) => {
        return `${process.env.REACT_APP_API_URL}jerusalem/api/v2.0.0/files/${contractId}/file`;
    };

    return (
        <div className=''>
            <div style={{ overflowY: 'scroll', maxHeight: '60vh' }}>
                <div
                    className='d-flex align-items-center'
                    style={{
                        cursor: 'pointer',
                    }}
                    onClick={() => changeSelectedId('')}
                >
                    <i className=' ri-arrow-left-s-line'></i>
                    <span
                        style={{
                            marginLeft: 5,
                            textDecoration: 'underline',
                        }}
                    >
                        Volver
                    </span>
                </div>

                <div className='mt-3'>
                    <div className='row p-0 m-0'>
                        <div className='col-12 d-flex gap-5'>
                            <div className=''>
                                <h6 className='mb-1'>Empleado</h6>

                                {selectedInterruption && (
                                    <p>{selectedInterruption.fullName}</p>
                                )}

                                {selectedWorkshift && (
                                    <p>{selectedWorkshift.fullname}</p>
                                )}
                            </div>

                            <div className=''>
                                <h6 className='mb-1'>Fecha</h6>

                                {selectedInterruption && (
                                    <p>
                                        {new Date(
                                            selectedInterruption.startDate
                                        ).toLocaleDateString()}
                                        - {selectedInterruption.startHour}-{' '}
                                        {selectedInterruption.endHour}
                                    </p>
                                )}

                                {selectedWorkshift && (
                                    <p>
                                        {new Date(
                                            selectedWorkshift.startDate
                                        ).toLocaleDateString()}
                                    </p>
                                )}
                            </div>

                            {selectedInterruption && (
                                <div className=''>
                                    <h6 className='mb-1 p-0'>
                                        Programación Anterior
                                    </h6>
                                    <p>
                                        {selectedInterruption.previousWorkshiftName}
                                    </p>
                                </div>
                            )}

                            {selectedWorkshift && (
                                <div className=''>
                                    <h6 className='mb-1 p-0'>
                                        Programación Anterior
                                    </h6>
                                    <p>{selectedWorkshift.previousWorkshiftName}</p>
                                </div>
                            )}

                            <div className=''>
                                <h6 className='mb-1'>Nueva programación</h6>
                                <p>
                                    {type == 'workshift'
                                        ? selectedWorkshift?.workshiftName
                                        : selectedInterruption?.interruptionTypeName}
                                </p>
                            </div>

                            {selectedInterruption && (
                                <div className=''>
                                    <h6 className='mb-1 p-0'>Observaciones</h6>
                                    <p>{selectedInterruption.comments}</p>
                                </div>
                            )}

                            {selectedInterruption?.fileUrl && (
                                <div className=''>
                                    <h6 className='mb-1'>Archivo</h6>
                                    <a
                                        className=' btn btn-info btn-sm'
                                        href={downloadFile(
                                            selectedInterruption.interruptionRequestId
                                        )}
                                        target='_blank'
                                    >
                                        <i className='ri-file-download-line'></i>
                                        Descargar
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className='text-start col-12'>
                    <textarea
                        placeholder='Escribe las observaciones...'
                        className='form-control'
                        id='exampleFormControlTextarea1'
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                    ></textarea>
                </div>

                <div className='mt-3 w-50 d-flex gap-2'>
                    {status !== 'rejected' && (
                        <button
                            onClick={() => {
                                handlerSubmit('approved');
                            }}
                            disabled={comments.length == 0 || isLoading}
                            className='w-100 btn btn-success d-flex align-items-center justify-content-center gap-1'
                        >
                            {isLoading ? (
                                <>Aprobando...</>
                            ) : (
                                <>
                                    <i className=' ri-checkbox-circle-line fs-5'></i>
                                    Aprobar
                                </>
                            )}
                        </button>
                    )}

                    {status !== 'approved' && (
                        <button
                            onClick={() => {
                                handlerSubmit('rejected');
                            }}
                            disabled={comments.length == 0 || isLoading}
                            className='w-100 btn btn-danger d-flex align-items-center justify-content-center gap-1'
                        >
                            {isLoading ? (
                                <>Rechazando...</>
                            ) : (
                                <>
                                    <i className='  ri-close-circle-line fs-5'></i>
                                    Rechazar
                                </>
                            )}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};